// extracted by mini-css-extract-plugin
export default {"tabsContainer":"ActivityTabs__tabsContainer___hHL9q"};